import React from 'react'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'
import { ModalSeeker, IconSeeker } from '@ui-seeker/core'
import { Grid, Typography, Box } from '@mui/material'
import DestinationUser from 'Pages/Admin/ReportsHandler/Modal/UserDestination'


export default function ReportsHandlerModal() {


	if(!isOpenReportsTransferModal.value?.length) return null


	return <ModalSeeker
		isOpen={!!isOpenReportsTransferModal.value?.length}
		controller={() => isOpenReportsTransferModal.value = []}
		title='Select the user that will receive the reports'
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Typography>Selected Reports:</Typography>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, flexWrap: 'wrap' }} >
					{isOpenReportsTransferModal.value.map(({ name, numSearches }) => <Box
						key={name}
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							backgroundColor: 'secondary.lighter',
							borderRadius: '8px',
							p: .5,
							gap: 1,
							width: '30%'
						}}
					>
						<IconSeeker icon='circle' sx={{ color: numSearches > 1000 ? 'colors.red' : 'colors.green' }} />
						<Typography variant='caption'>{name}</Typography>
					</Box>)}
				</Box>
			</Grid>
			<Grid item xs={12}>
				<DestinationUser />
			</Grid>
		</Grid>
	</ModalSeeker>
}